import React, { useEffect, useState } from 'react'
import { Col, Form, InputGroup, Row } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { formatFecha, getTableBd, insertTableBd, updateTableBd } from '../../config/functions'

const CAMPOS_CONSUMO = [
    { key: 'generador_1', label: 'Generador 1' },
    { key: 'generador_2', label: 'Generador 2' },
    { key: 'unidad_basica', label: 'Unidad Básica' },
    { key: 'bomba_lodos', label: 'Bomba de Lodos' },
    { key: 'grua', label: 'Grúa' },
    { key: 'cargador', label: 'Cargador' },
    { key: 'pipe_handler', label: 'Pipe Handler' },
    { key: 'planta_estadio', label: 'Planta Estadio' },
    { key: 'limpieza_tuberia', label: 'Limpieza de Tubería' },
    { key: 'camioneta', label: 'Camioneta' },
    { key: 'tractocamion', label: 'Tractocamión' },
    { key: 'otros', label: 'Otros' },
]

export const DOReportCombustible = ({
    idrde,
    user,
    mobile
}) => {

    const [registro, setRegistro] = useState(null)
    const [esNuevo, setEsNuevo] = useState(true)
    const [editando, setEditando] = useState(false)

    const [stock, setStock] = useState(0)
    const [ayer, setAyer] = useState(0)
    const [recibido, setRecibido] = useState(0)

    const [consumos, setConsumos] = useState({
        generador_1: 0,
        generador_2: 0,
        unidad_basica: 0,
        bomba_lodos: 0,
        grua: 0,
        cargador: 0,
        pipe_handler: 0,
        planta_estadio: 0,
        limpieza_tuberia: 0,
        camioneta: 0,
        tractocamion: 0,
        otros: 0,
    })

    const [totalConsumo, setTotalConsumo] = useState(0)
    const [existenciaHoy, setExistenciaHoy] = useState(0)

    const [verificado, setVerificado] = useState(false)
    const [usuarioVerifica, setUsuarioVerifica] = useState('')
    const [fechaVerifica, setFechaVerifica] = useState('')

    // Auto-calcular total consumo y existencia
    useEffect(() => {
        const sumaConsumos = Object.values(consumos).reduce((acc, val) => acc + (parseFloat(val) || 0), 0)
        setTotalConsumo(parseFloat(sumaConsumos.toFixed(2)))
        setExistenciaHoy(parseFloat(((parseFloat(stock) || 0) + (parseFloat(recibido) || 0) - sumaConsumos).toFixed(2)))
    }, [consumos, stock, recibido])

    // Cargar datos
    useEffect(() => {
        if (idrde) {
            getDatos()
        }
    }, [idrde])

    const getDatos = async () => {
        try {
            const data = await getTableBd('getCombustibleRDE/' + idrde)
            if (data.length > 0) {
                const reg = data[0]
                setRegistro(reg)
                setEsNuevo(false)
                setEditando(false)
                setStock(reg.stock || 0)
                setAyer(reg.ayer || 0)
                setRecibido(reg.recibido || 0)
                setConsumos({
                    generador_1: reg.generador_1 || 0,
                    generador_2: reg.generador_2 || 0,
                    unidad_basica: reg.unidad_basica || 0,
                    bomba_lodos: reg.bomba_lodos || 0,
                    grua: reg.grua || 0,
                    cargador: reg.cargador || 0,
                    pipe_handler: reg.pipe_handler || 0,
                    planta_estadio: reg.planta_estadio || 0,
                    limpieza_tuberia: reg.limpieza_tuberia || 0,
                    camioneta: reg.camioneta || 0,
                    tractocamion: reg.tractocamion || 0,
                    otros: reg.otros || 0,
                })
                setTotalConsumo(reg.total_consumo || 0)
                setExistenciaHoy(reg.existencia_hoy || 0)
                setUsuarioVerifica(reg.usuario_verifica || '')
                setFechaVerifica(reg.fecha_verifica || '')
                setVerificado(reg.usuario_verifica !== '' && reg.usuario_verifica !== null)
            } else {
                setEsNuevo(true)
                setEditando(false)
                setRegistro(null)
                setVerificado(false)
                setUsuarioVerifica('')
            }
        } catch (error) {
            console.error(error)
        }
    }

    const camposDeshabilitados = verificado || (!esNuevo && !editando)

    const setConsumoField = (key, value) => {
        setConsumos(prev => ({ ...prev, [key]: parseFloat(value) || 0 }))
    }

    const guardar = async () => {
        const dataSend = {
            id_rde: idrde,
            stock, ayer, recibido,
            ...consumos,
            total_consumo: totalConsumo,
            existencia_hoy: existenciaHoy,
            usuario: user
        }

        try {
            if (esNuevo) {
                await insertTableBd('createCombustible', dataSend)
                toast.success('Combustible guardado')
            } else {
                dataSend.id = registro.id
                await updateTableBd('updateCombustible', dataSend)
                toast.success('Combustible actualizado')
            }
            getDatos()
        } catch (error) {
            console.error(error)
            toast.error('Error al guardar Combustible')
        }
    }

    const verificar = async () => {
        if (esNuevo) {
            toast.warning('Debe guardar primero el registro')
            return
        }
        if (!window.confirm('¿Está seguro de verificar Combustible? Una vez verificado no se podrá editar.')) return

        const now = new Date()
        now.setHours(now.getHours() - 5)
        const dataSend = {
            id: registro.id,
            usuario_verifica: user,
            fecha_verifica: now.toISOString()
        }

        try {
            await updateTableBd('verificarCombustible', dataSend)
            toast.success('Combustible verificado')
            getDatos()
        } catch (error) {
            console.error(error)
            toast.error('Error al verificar')
        }
    }

    const inputField = (label, value, setter, className = '') => (
        <InputGroup className="mb-1" size="sm">
            <InputGroup.Text style={{ minWidth: mobile ? '140px' : '180px' }} className={className}>
                {label}
            </InputGroup.Text>
            <Form.Control
                type="number"
                size="sm"
                value={value}
                disabled={camposDeshabilitados}
                onChange={(e) => setter(parseFloat(e.target.value) || 0)}
                step="0.01"
                className={className}
            />
        </InputGroup>
    )

    return (
        <div className="mt-2">
            {verificado && (
                <Row className="justify-content-md-center mb-2">
                    <h6 className='text-success'>Verificado por: {usuarioVerifica}</h6>
                    <h6 className='text-success'>Fecha Verificación: {formatFecha(fechaVerifica)}</h6>
                </Row>
            )}

            <Row className="mt-2 justify-content-md-center">
                <Col className="text-center">
                    <h5 style={{ fontSize: mobile && '16px' }}>Combustible (A.C.P.M.)</h5>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col sm={6} md={4}>
                    {inputField('Stock', stock, setStock, 'border-primary')}
                </Col>
                <Col sm={6} md={4}>
                    {inputField('Ayer', ayer, setAyer, 'border-primary')}
                </Col>
                <Col sm={6} md={4}>
                    {inputField('Recibido', recibido, setRecibido, 'border-primary')}
                </Col>
            </Row>

            <hr className="mt-1 mb-2" />

            <Row>
                <Col sm={12}>
                    <h6 className="text-muted mb-1" style={{ fontSize: mobile && '13px' }}>Consumos por Equipo</h6>
                </Col>
            </Row>

            <Row>
                {CAMPOS_CONSUMO.map((campo) => (
                    <Col sm={6} md={4} key={campo.key}>
                        <InputGroup className="mb-1" size="sm">
                            <InputGroup.Text style={{ minWidth: mobile ? '140px' : '180px' }}>
                                {campo.label}
                            </InputGroup.Text>
                            <Form.Control
                                type="number"
                                size="sm"
                                value={consumos[campo.key]}
                                disabled={camposDeshabilitados}
                                onChange={(e) => setConsumoField(campo.key, e.target.value)}
                                step="0.01"
                            />
                        </InputGroup>
                    </Col>
                ))}
            </Row>

            <hr className="mt-1 mb-2" />

            <Row>
                <Col sm={6}>
                    <InputGroup className="mb-2" size="sm">
                        <InputGroup.Text style={{ minWidth: mobile ? '140px' : '180px' }} className="bg-warning text-dark fw-bold">
                            Total Consumo
                        </InputGroup.Text>
                        <Form.Control
                            type="number"
                            size="sm"
                            value={totalConsumo}
                            disabled={true}
                            className="bg-warning text-dark fw-bold"
                        />
                    </InputGroup>
                </Col>
                <Col sm={6}>
                    <InputGroup className="mb-2" size="sm">
                        <InputGroup.Text style={{ minWidth: mobile ? '140px' : '180px' }} className="bg-success text-white fw-bold">
                            Existencia Hoy
                        </InputGroup.Text>
                        <Form.Control
                            type="number"
                            size="sm"
                            value={existenciaHoy}
                            disabled={true}
                            className="bg-success text-white fw-bold"
                        />
                    </InputGroup>
                </Col>
            </Row>

            {!verificado && (
                <Row className="mt-2 mb-3 justify-content-md-center">
                    <Col xs="auto">
                        {esNuevo ? (
                            <button
                                className='btn btn-sm btn-outline-primary'
                                onClick={guardar}>
                                <i className="fa-solid fa-floppy-disk me-1"></i> Guardar
                            </button>
                        ) : !editando ? (
                            <button
                                className='btn btn-sm btn-outline-secondary'
                                onClick={() => setEditando(true)}>
                                <i className="fa-solid fa-pen-to-square me-1"></i> Editar
                            </button>
                        ) : (
                            <div className="btn-group">
                                <button
                                    className='btn btn-sm btn-outline-primary'
                                    onClick={guardar}>
                                    <i className="fa-solid fa-floppy-disk me-1"></i> Guardar
                                </button>
                                <button
                                    className='btn btn-sm btn-outline-secondary'
                                    onClick={() => { setEditando(false); getDatos() }}>
                                    <i className="fa-solid fa-xmark me-1"></i> Cancelar
                                </button>
                            </div>
                        )}
                    </Col>
                    {!esNuevo && (
                        <Col xs="auto">
                            <button
                                className='btn btn-sm btn-outline-success'
                                onClick={verificar}>
                                <i className="fa-solid fa-check-double me-1"></i> Verificar
                            </button>
                        </Col>
                    )}
                </Row>
            )}
        </div>
    )
}
